import React from 'react';

import { FiAlertCircle, FiClock, FiFolder, FiHome, FiStar, FiTrash2 } from 'react-icons/fi';

export const SideButtons = [
  {
    id: 1,
    className: 'btn btn-primary',
    icon: <FiHome />,
    title: 'Home',
  },
  {
    id: 2,
    className: 'btn btn-light',
    icon: <FiFolder />,
    title: 'All',
  },
  {
    id: 3,
    className: 'btn btn-light',
    icon: <FiClock />,
    title: 'Recent',
  },
  {
    id: 4,
    className: 'btn btn-light',
    icon: <FiStar />,
    title: 'Starred',
  },
  {
    id: 5,
    className: 'btn btn-light',
    icon: <FiAlertCircle />,
    title: 'Recovery',
  },
  {
    id: 6,
    className: 'btn btn-light',
    icon: <FiTrash2 />,
    title: 'Deleted',
  },
];

export const QuickAccessData = [
  {
    title: 'Videos',
    icon: <i className='fa fa-youtube-play font-danger' />,
  },
  {
    title: 'Apps',
    icon: <i className='fa fa-th font-info'></i>,
  },
  {
    title: 'Document',
    icon: <i className='fa fa-file-text-o font-secondary'></i>,
  },
  {
    title: 'Music',
    icon: <i className='fa fa-music font-warning'></i>,
  },
  {
    title: 'Download',
    icon: <i className='fa fa-download font-primary'></i>,
  },
  {
    title: 'Folder',
    icon: <i className='fa fa-folder font-info'></i>,
  },
  {
    title: 'Zip File',
    icon: <i className='fa fa-file-archive-o font-secondary'></i>,
  },
  {
    title: 'Trash',
    icon: <i className='fa fa-trash font-danger'></i>,
  },
];
